// Shape of the `default-release-configuration` JSON flag, maintained by Release Engineering. It is the
// template Vega uses to record an automated rollout config; the flag Overview page reads it to offer a
// one-click "create the default rollout" action. Fields are snake_case to match the flag's JSON exactly.

export type DefaultReleaseConfigurationOverride = {
  release_method: 'immediate' | 'progressive' | 'guarded';
  stages?: Array<{ allocation: number; duration_millis: number }>;
  metric_keys?: string[];
  metric_group_keys?: string[];
  rollback_on_regression?: boolean;
  rollout_context_kind_key?: string;
};

export type DefaultReleaseConfigurationEnvironment = {
  environment_key: string;
  release_type: 'policy' | 'override';
  override?: DefaultReleaseConfigurationOverride;
  wait_before_release_millis?: number;
  trigger_type?: 'flag_eval' | 'webhook' | 'manual' | 'promotion';
};

export type DefaultReleaseConfiguration = {
  // Present and false on the flag's "off" variation.
  enabled?: boolean;
  environments?: DefaultReleaseConfigurationEnvironment[];
  execution_mode?: 'parallel' | 'sequential';
  required_application_keys?: string[];
};

export const DEFAULT_RELEASE_CONFIGURATION_OFF: DefaultReleaseConfiguration = { enabled: false };
